import { _ as __rest, a as __assign } from './tslib.es6-ba4e1897.js';
import React from 'react';
import cn from 'classnames';
import { ChevronRight, ChevronLeft } from '@heycar-uikit/icons/dist/esm';
import Typography from '@heycar-uikit/typography/dist/esm';
import { P as PaginationItemType } from './Pagination.types-ebdb9f29.js';

var styles = {"pagination":"pagination__pagination_sgrs2","disabled":"pagination__disabled_sgrs2","currentPage":"pagination__currentPage_sgrs2","itemNumber":"pagination__itemNumber_sgrs2","arrow":"pagination__arrow_sgrs2","ellipsis":"pagination__ellipsis_sgrs2","slash":"pagination__slash_sgrs2"};
 require('./styles/default.css')

var PaginationItem = function (_a) {
    var page = _a.page, isCurrentPage = _a.isCurrentPage, isDisabled = _a.isDisabled, itemType = _a.itemType, onClick = _a.onClick, _b = _a.component, component = _b === void 0 ? onClick ? 'button' : 'a' : _b, rest = __rest(_a, ["page", "isCurrentPage", "isDisabled", "itemType", "onClick", "component"]);
    var Component = component;
    switch (itemType) {
        case PaginationItemType.PageNumber:
            return (React.createElement(Component, __assign({ className: cn(styles.itemNumber, isCurrentPage && styles.currentPage) }, rest, { "aria-current": isCurrentPage, onClick: onClick }),
                React.createElement(Typography, { variant: "subheading2" }, page)));
        case PaginationItemType.Ellipsis:
            return (React.createElement(Typography, { className: styles.ellipsis, variant: "subheading2" }, '...'));
        case PaginationItemType.Slash:
            return (React.createElement(Typography, { className: styles.slash, variant: "subheading2" }, '/'));
        case PaginationItemType.Previous:
            return (React.createElement(Component, __assign({ className: cn(styles.arrow, isDisabled && styles.disabled) }, rest, { onClick: onClick }),
                React.createElement(ChevronLeft, null)));
        case PaginationItemType.Next:
            return (React.createElement(Component, __assign({ className: cn(styles.arrow, isDisabled && styles.disabled) }, rest, { onClick: onClick }),
                React.createElement(ChevronRight, null)));
    }
};

export { PaginationItem as P, styles as s };
